import type { ITime, ITimeMapping } from './models';

const timeMapping: ITimeMapping = {
    hh: 'hours',
    mm: 'minutes',
    ss: 'seconds',
};

const convertTime = (a: number): string => (a < 10 ? `0${a}` : `${a}`);

/**
 * Конвертирует строку секунд в строку времени `hh:mm:ss`. См. примеры в тестах.
 */
export const secondsToTime = (s = '0', f = 'hh:mm:ss'): string => {
    let sec = parseInt(s, 10);
    let format = f;

    const seconds = sec % 60;

    sec = (sec - seconds) / 60;
    const minutes = sec % 60;
    const hours = (sec - minutes) / 60;

    const time: ITime = {
        seconds,
        minutes,
        hours,
    };

    Object.entries(timeMapping).forEach(([key, value]: string[]): void => {
        format = format.replace(key, convertTime(time[value]));
    });

    return format;
};
